import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=66e9403a&scoped=true&"
import script from "./collection.vue?vue&type=script&lang=js&"
export * from "./collection.vue?vue&type=script&lang=js&"
import style0 from "./collection.vue?vue&type=style&index=0&id=66e9403a&prod&lang=css&"
import style1 from "./collection.vue?vue&type=style&index=1&id=66e9403a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9403a",
  null
  
)

export default component.exports